import { render } from "./Dots.vue?vue&type=template&id=305aad36"
import script from "./Dots.vue?vue&type=script&lang=js"
export * from "./Dots.vue?vue&type=script&lang=js"

import "./Dots.vue?vue&type=style&index=0&id=305aad36&lang=scss"

import exportComponent from "/var/www/patternmaking/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__